import React from 'react';
import ButtonLink from '../../Form/ButtonLink';
import ProfileTitle from '../../../Pages/Profile/ProfileTitle';
import CardOrder from './CardOrder';
import { TbMoodConfuzed } from 'react-icons/tb';
import { ImSpinner8 } from 'react-icons/im';
import { useOrderHook } from '../../../Hooks/OrderHook';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CardProfileOrdersProps {
     loading: boolean;
     list: any[];
}

const CardProfileOrders = ({ loading=true, list }: CardProfileOrdersProps) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { handleGetDetail } = useOrderHook();

    return (
            <div className='flex flex-col gap-4 w-full'>
                <ProfileTitle className='h-auto'>{t('profile.orders.title_card_home')}</ProfileTitle>
                <div className="flex flex-col h-full divide-y rounded-none divide-gray-100">

                    {loading
                        ?   <div className="flex items-center gap-1 text-gray-500"><ImSpinner8 className="animate-spin" /><span>{t('layout.loading')}</span></div>
                        :   (Array.isArray(list) && list.length === 0) || !list
                                ?   <div className="flex items-center gap-1 text-gray-500"><TbMoodConfuzed /> <span>{t('profile.orders.no_orders_found')}</span></div>
                                :   list.map((order: any, index: number) => (
                                        <CardOrder order={order} onClick={() => handleGetDetail(order)} key={order.id ?? index} />
                                    ))
                    }

                </div>
                {!loading && <ButtonLink onClick={() => navigate('/perfil/meus-pedidos')} className='w-full md:w-max'>{t('profile.orders.button_card_home_label')}</ButtonLink>}
            </div>
        )
    }

export default CardProfileOrders;